// A small, closed, effectively permanent enumeration — hardcoded here
// rather than reference data, same reasoning as usStates.js/
// wisconsinCounties.js: no per-locale variation, no reason to grow via
// data entry. Positions are team/season-specific (team_athletes, 012),
// never stored on athletes itself.
export const FOOTBALL_POSITIONS = [
  { code: 'QB', name: 'Quarterback' },
  { code: 'RB', name: 'Running Back' },
  { code: 'FB', name: 'Fullback' },
  { code: 'WR', name: 'Wide Receiver' },
  { code: 'TE', name: 'Tight End' },
  { code: 'LT', name: 'Left Tackle' },
  { code: 'LG', name: 'Left Guard' },
  { code: 'C',  name: 'Center' },
  { code: 'RG', name: 'Right Guard' },
  { code: 'RT', name: 'Right Tackle' },
  { code: 'OL', name: 'Offensive Line' },
  { code: 'DE', name: 'Defensive End' },
  { code: 'DT', name: 'Defensive Tackle' },
  { code: 'DL', name: 'Defensive Line' },
  { code: 'LB', name: 'Linebacker' },
  { code: 'CB', name: 'Cornerback' },
  { code: 'S',  name: 'Safety' },
  { code: 'DB', name: 'Defensive Back' },
  { code: 'K',  name: 'Kicker' },
  { code: 'P',  name: 'Punter' },
  { code: 'LS', name: 'Long Snapper' },
];

export function positionLabel(code) {
  if (!code) return null;
  const p = FOOTBALL_POSITIONS.find(p => p.code === code);
  return p ? p.name : code;
}

/** "RB / LB", or "—" when neither is set — the one shared way a roster
 * membership's primary/secondary position pair is displayed. Takes any
 * object carrying primary_position/secondary_position (a team_athletes
 * row, or an athleteTeamMemberships row shaped the same way) — phase
 * C.6 extracted this from TeamRosterPage.js's own local helper so
 * FootballHistorySection.js doesn't need a second copy. */
export function formatPositions(row) {
  const parts = [row?.primary_position, row?.secondary_position].filter(Boolean).map(positionLabel);
  return parts.length ? parts.join(' / ') : '—';
}
